module["exports"] = {
  "adjective": ["Liten", "Ergonomisk", "Robust", "Intelligent", "Söt", "Otrolig", "Fantastisk", "Praktisk", "Slimmad", "Grym"],
  "material": ["Stål", "Metall", "Trä", "Betong", "Plast", "Bomull", "Granit", "Gummi", "Latex"],
  "product": ["Stol", "Bil", "Dator", "Handskar", "Byxor", "Skjorta", "Bord", "Skor", "Hatt"]
};